var _Rect, _Path, _Path2, _Path3, _Path4, _Path5, _Rect2, _Rect3, _Path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";
var SvgEs = function SvgEs(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none"
  }, props), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    width: 28,
    height: 20,
    fill: "#fff",
    rx: 2
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#DD172C",
    fillRule: "evenodd",
    d: "M0 5.333h28V0H0zM0 20h28v-5.333H0z",
    clipRule: "evenodd"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "#FFD133",
    fillRule: "evenodd",
    d: "M0 14.667h28V5.333H0z",
    clipRule: "evenodd"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    fill: "#FFEDB1",
    fillRule: "evenodd",
    d: "M7.334 9.333h1.333V10H7.334z",
    clipRule: "evenodd"
  })), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    stroke: "#A41517",
    strokeWidth: 0.667,
    d: "M6.059 9.361a.333.333 0 0 1 .332-.36h1.884c.195 0 .349.166.332.36l-.17 2.055a1 1 0 0 1-.997.917h-.213a1 1 0 0 1-.997-.917z"
  })), _Path5 || (_Path5 = /*#__PURE__*/React.createElement(Path, {
    fill: "#A41517",
    fillRule: "evenodd",
    d: "M6 10h2.667v.667H8L7.333 12l-.666-1.333H6z",
    clipRule: "evenodd"
  })), _Rect2 || (_Rect2 = /*#__PURE__*/React.createElement(Rect, {
    width: 1.333,
    height: 4.667,
    x: 4,
    y: 8,
    fill: "#A41517",
    rx: 0.667
  })), _Rect3 || (_Rect3 = /*#__PURE__*/React.createElement(Rect, {
    width: 1.333,
    height: 4.667,
    x: 9.334,
    y: 8,
    fill: "#A41517",
    rx: 0.667
  })), _Path6 || (_Path6 = /*#__PURE__*/React.createElement(Path, {
    fill: "#A41517",
    d: "M6 7.733c0-.589.478-1.066 1.067-1.066H7.6c.59 0 1.067.477 1.067 1.066 0 .148-.12.267-.267.267H6.267A.267.267 0 0 1 6 7.733"
  })));
};
export default SvgEs;